import Papa from 'papaparse'
import { useEffect } from 'react'


export const useGetCsvData = (file, setState) => {
    
    useEffect(() => {
        let results = []
        if (file) {
            Papa.parse(file, {
                skipEmptyLines: 'greedy',
                step: function(result) {
                    results.push(result)
                }
            })
            setState(results)
        }
        
    }, [file, setState])
} 